import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { TranslateText } from '../../../../../../application/language/TranslateText';
import { IProjectLearningReportArg } from '../../../../../../service/report/interface/IProjectLearningReportArg';
import { UserRatingsContent } from '../../../../../analytics/components/RatingsSection/UserRatingsContent';
import { MetricsSection } from '../../../../../analytics/shared/MetricsSection';
import { MetricsDomain } from '../../../../../analytics/shared/MetricsSection/store/MetricsDomain';
import { MetricsHistorySection } from '../../../../../analytics/shared/MetricsHistorySection';

type IProjectUsersContentProperties = {
  reportArg: IProjectLearningReportArg;
};

export const ProjectUsersContent = observer(({ reportArg }: IProjectUsersContentProperties) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, flex: 1, minHeight: 0, overflow: 'auto' }}>
      <MetricsSection key={`metrics-${reportArg.projectIds?.[0] || 'project'}`} metricsDomain={new MetricsDomain()} reportArg={reportArg} averageProgressLabelKey="learningReport.metrics.averageProgressProject.label" />
      {/* <MetricsHistorySection key={`history-${reportArg.projectIds?.[0] || 'project'}`} reportArg={reportArg} /> */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1, minHeight: 0 }}>
        <Typography variant="h6">
          <TranslateText i18nKey="analytics.users" />
        </Typography>
        <Box >
          <UserRatingsContent key={`users-${reportArg.projectIds?.[0] || 'project'}`} reportArg={reportArg} />
        </Box>
      </Box>
    </Box>
  );
});
